module.exports = __webpack_public_path__ + "static/media/Frame.75c0d97b.svg";